import {useMemo, useRef} from 'react';
import {assert} from 'assert-ts';
import isEqual from 'lodash/isEqual';
import {useAppSelector} from 'store/hooks';
import type {ExpressionImportProps} from '../types';
import {
  selectMetadataEditExportsExpressionById,
  selectMetadataEditExportsWork,
} from '../metadataEditSlice';
import {useCreateSelectorById} from './useCreateSelectorById';

export const useExpressionImportProps = (
  expressionId: string,
): ExpressionImportProps => {
  const workExports = useAppSelector(selectMetadataEditExportsWork);
  const expressionExportsSelector = useCreateSelectorById(
    expressionId,
    selectMetadataEditExportsExpressionById,
  );
  const expressionExports = useAppSelector(expressionExportsSelector);

  const exportsRef = useRef<ExpressionImportProps>(undefined);

  return useMemo(() => {
    const newExports = {
      work: workExports,
      expression: assert(
        expressionExports,
        'useExpressionImportProps: unknown expressionId',
      ),
    };

    if (!isEqual(newExports, exportsRef.current)) {
      exportsRef.current = newExports;
    }

    return assert(exportsRef.current);
  }, [expressionExports, workExports]);
};
